// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"dd9ca6d1","644":"2b1269ce","832":"4f2fa5cc"}[chunkId] + ".chunk.js";
};